import gql from 'graphql-tag';

export default gql`
  mutation GoalChangeMutation($goalWeight: UserMeasurementWeightInputType!) {
    me {
      goalChange(goalWeight: $goalWeight) {
        __typename
        ... on BasicMutationSuccess {
          code
        }
        ... on UnauthorizedException {
          code
        }
        ... on ValidationException {
          code
          messages
          details {
            fieldName
            messages
          }
        }
      }
    }
  }
`;
